export default __webpack_public_path__ + "locales/es/Files.json?hash=ca37d8beb3782aae1d4b119252323c83";